import { render, staticRenderFns } from "./DatePickerControl.vue?vue&type=template&id=2b96c8fe&scoped=true&"
import script from "./DatePickerControl.vue?vue&type=script&lang=js&"
export * from "./DatePickerControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96c8fe",
  null
  
)

export default component.exports